import { getToken } from '~/src/dash/api/auth/auth';
import { IAnalytics, transformAnalytics } from '~/src/dash/api/console-api';
import {
  parseArray,
  parseBoolFalse,
  parseNumber,
  parseString,
  transformModel,
} from '~/src/dash/api/resource-transforms';
import { IHttpResponse, restGet } from '~/src/dash/api/rest';
import { getApiDomain } from '~/src/dash/resellers/utils/importResellerConfig';

export interface ISiteCampaignBookedImpressionsMap {
  [siteID: string]: ICampaignBookedImpressionsMap;
}

export interface ISiteDealBookedImpressionsMap {
  [siteID: string]: ISiteBookedImpressionsMap;
}

export interface ICampaignBookedImpressionsMap {
  [campaignID: string]: IBookedCampaignImpressionInfo;
}

export interface ISiteBookedImpressionsMap {
  [dealID: string]: IBookedDealImpressionInfo;
}

export interface IBookedImpressionInfo {
  BookedImpressions: number;
  SiteShareOfImpressions: number;
  CPM: number;
  SiteName: string;
}

export interface IBookedCampaignImpressionInfo extends IBookedImpressionInfo {
  CampaignName: string;
}

export interface IBookedDealImpressionInfo extends IBookedImpressionInfo {
  DealName: string;
}

export interface IForecastInventoryResponse {
  BookedImpressions: number;
  Analytics: IAnalytics[];
  SiteCampaignBookedImpressionsMap: ISiteCampaignBookedImpressionsMap;
  SiteDealBookedImpressionsMap: ISiteDealBookedImpressionsMap;
  Query: string;
  Success: boolean;
}

export async function getInventoryForecast(
  bidderIDs: string,
  siteIDs: string,
  startDate: string,
  endDate: string,
  timezone: string,
  deviceTypes: string,
  deviceSubtypes: string,
  publisherID: string,
): Promise<IHttpResponse<IForecastInventoryResponse>> {
  const tokenObj = getToken();
  const accessToken = tokenObj.access_token;
  const queryParams = `&bidder_ids=${bidderIDs}&site_ids=${siteIDs}&start_date=${startDate}&end_date=${endDate}&timezone=${timezone}&device_types=${deviceTypes}&device_subtypes=${deviceSubtypes}&publisher_id=${publisherID}`;
  const reqURL =
    getApiDomain() +
    `/v1/analytics/discovery/get_inventory_forecast?access_token=${accessToken}` +
    queryParams;
  return await restGet<IForecastInventoryResponse>(reqURL, {});
}

export const transformForecastInventoryResponse = transformModel<IForecastInventoryResponse>({
  BookedImpressions: parseNumber('booked_impressions'),
  Analytics: parseArray('data', transformAnalytics),
  SiteCampaignBookedImpressionsMap: 'site_campaign_booked_impressions_map',
  SiteDealBookedImpressionsMap: 'site_deal_booked_impressions_map',
  Query: parseString('query'),
  Success: parseBoolFalse('success'),
});
